import React from 'react';
import { Container } from '@hover/blueprint';
import {
  Layout,
  StillHaveQuestions,
  BackToTopButton,
  UtilityMenuBanner,
} from '../common';
import Hero from './Hero';
import TableOfContent from './TableOfContent';
import { ILink } from '../../interfaces/ILink';

interface Props {
  heroLinks?: React.ReactNode;
  revisedDate: string;
  content: React.ReactNode;
  description: React.ReactNode;
  tableOfContent: Array<ILink>;
}

const PrivacyWrapper: React.FC<Props> = ({
  heroLinks,
  content,
  description,
  revisedDate,
  tableOfContent,
}) => (
  <Layout
    title="Privacy"
    navbarBackgroundColor="orange.100"
    isNavbarWhite={false}
    titleColor="neutral.900"
    bannerElement={<UtilityMenuBanner />}
  >
    <Hero heroLinks={heroLinks} revisedDate={revisedDate} />
    <Container maxW="1312px" px={{ base: 500, tablet: '56px' }}>
      {description}
      <TableOfContent tableData={tableOfContent} />
      {content}
    </Container>
    <StillHaveQuestions />
    <BackToTopButton />
  </Layout>
);

export default PrivacyWrapper;
